export default {
  computed: {
    showPaymentSuccessful: {
      get: function() {
        const result = this.$store.getters['square/processingResult']
        if (this.type === 'payment' && result && result.payment) {
          return ['APPROVED', 'COMPLETED'].includes(result.payment.status)
        }
        else if (this.type === 'card' && result) {
          return !!(result.status && result.type === 'card')
        }
        return false
      },
      set: function() { }
    },
    showPaymentFailure: {
      get: function() {
        if (this.type === 'payment') {
          return this.processingResult && !this.processingResult.status && this.processingResult.payment && ['CANCELED', 'FAILED'].includes(this.processingResult.payment.status)
        }
        else if (this.type === 'card') {
          return !!(this.processingResult && !this.processingResult.status && !Object.prototype.hasOwnProperty.call(this.processingResult, 'error'))
        }
        return false
      },
      set: function() { }
    },
    showPaymentError: {
      get: function() {
        // Don't show error modal if failure modal is already being shown for payment failures
        if (this.type === 'payment' && this.showPaymentFailure) {
          return false
        }
        return !!(this.processingResult && !this.processingResult.status && Object.prototype.hasOwnProperty.call(this.processingResult, 'error'))
      },
      set: function() { }
    }
  },
  methods: {
    modalClosed: function() {
      this.$emit('closed', true)
    }
  }

}
